/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAnglesLeft,
  faAnglesRight,
  faAngleLeft,
  faAngleRight,
  faAngleDown,
  faAngleUp,
  faThumbsDown,
  faThumbsUp,
  faMinus,
  faCopy,
  faArrowUp,
  faArrowDown,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight,
  faAngleDown,
  faAngleUp,
  faThumbsDown,
  faThumbsUp,
  faCopy,
  faMinus,
  faArrowUp,
  faArrowDown,
  faXmark
);

export default FontAwesomeIcon;
